export default "__VITE_ASSET__oxVJSZ5s__"